import React from "react";
import diagramUrl from "../assets/application-note-diagram.svg";

const ApplicationNoteDiagram: React.FC = () => (
  <img
    src={diagramUrl}
    alt="Producer to consumer flow with cloud intelligence detecting anomalies and counterfeiter injections"
    style={{ width: "100%", height: "auto" }}
  />
);

export default ApplicationNoteDiagram;
